export default __webpack_public_path__ + "static/media/atualize-dados.f2cc32ce.png";